import styled from 'styled-components';

import { staffImportTokens } from '../styles/staffImportTokens';

export const StaffImportSectionDivider = styled.hr`
    width: 100%;
    height: 1px;
    margin: 0;
    border: none;
    background: ${staffImportTokens.colors.grey5};
`;

export default StaffImportSectionDivider;
